<template>
    <popup-wrapper
        class="popup-comm"
        v-if="popShow"
        @pop-cls="handlePopCls"
        :hasCls="commText.hasCls"
        :size="commText.size"
    >
        <p v-html="commText.text"></p>
        <div class="btn-dw" @click="toDownload" v-if="commText.hasDownload">
            {{ $t('base.download_btn') }}
        </div>
    </popup-wrapper>
</template>

<script>
import { mapActions, mapMutations } from 'vuex';
import popupWrapper from '@/components/popup/popup-wrapper';
export default {
    name: 'popup-comm',
    components: {
        popupWrapper
    },
    computed: {
        popShow() {
            return this.$store.state.popup.comm;
        },
        commText() {
            return this.$store.state.commText;
        }
    },
    methods: {
        ...mapMutations(['PLAY_SOUND', 'STOP_SOUND']),
        handlePopCls() {
            this.$store.commit('HIDE_POPUP', 'comm');
        },
        toDownload() {
            this.PLAY_SOUND('button');
            window.open('https://app.adjust.com/2v1q75g_6ud1zdj');
        }
    }
};
</script>

<style lang="less" scoped>
/deep/ .popup-wrapper {
    box-sizing: border-box;
    padding: 80px 40px 50px;

    p {
        font-size: 24px;
        text-align: center;
        line-height: 1.8;
        color: #9c9273;
    }

    .btn-dw {
        width: 210px;
        height: 74px;
        background: url(~@/assets/img/btn_orange_square.png) center/100% 100%
            no-repeat;
        line-height: 74px;
        font-size: 24px;
        color: #fff;
        text-align: center;
        margin: 30px auto 0;
        font-weight: bold;
    }
}
</style>
